<template>
    <div class="form-group">
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ label }}</span>
            </div>
            <input type="text" 
                ref="date"
                class="form-control"
                pattern="\d{2}/\d{2}/\d{4}" 
                placeholder="mm/dd/yyyy"  
                maxlength="10"
                oninvalid="this.setCustomValidity('Please use mm/dd/yyyy')"
                oninput="this.setCustomValidity('')"
                v-on:keydown="onlyAllowNumbers"
                v-bind:value="value" 
                v-on:input="$emit('input', $event.target.value)"
                :required="required">
            <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" v-on:click="reset()">Reset</button>
            </div>                
        </div>
    </div>
</template>

<script>

export default {
  name: 'DateInput',
  props: {
      label: String,
      required: {
          type: Boolean,
          default: false
      },
      value: String
  },
  methods: {
      onlyAllowNumbers: function(event) {
        var e = event || window.event;
        var date = this.$refs.date.value;
        var allowedKeys = ["Backspace", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Tab"]
        if (allowedKeys.indexOf(e.key) == -1) {
            e.preventDefault();
            e.returnValue = false;
            return;
        }
        if ((date.length === 2 || date.length === 5) && e.key !== "Backspace") {
            this.$refs.date.value += "/";
        }
      },
      reset: function() {
          this.$refs.date.value = "";
      }
  }
}
</script>